import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './core/layout/home/home.component';
import { AuthGuard } from './core/auth/auth.guard';
import { ErrorComponent } from './core/layout/error/error.component';

const routes: Routes = [
  { path: '', component: HomeComponent, pathMatch: 'full' },
  { path: 'error', component: ErrorComponent },
  { path: 'unauthorized', loadComponent: () => import('./core/layout/unauthorized/unauthorized.component').then(m => m.UnauthorizedComponent) },
  { path: 'authentication', loadChildren: () => import('./modules/authentication/authentication.module').then(m => m.AuthenticationModule) },
  { path: 'calendar', loadChildren: () => import('./modules/calendar/calendar.module').then(m => m.CalendarModule), canActivate: [AuthGuard] },
  { path: 'dashboard', loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule), canActivate: [AuthGuard] },
  { path: 'compliance', loadChildren: () => import('./modules/compliance/compliance.module').then(m => m.ComplianceModule) },
  { path: 'patients', loadChildren: () => import('./modules/patients/patients.module').then(m => m.PatientsModule), canActivate: [AuthGuard] },
  { path: 'settings', loadChildren: () => import('./modules/settings/settings.module').then(m => m.SettingsModule), canActivate: [AuthGuard] },
  { path: 'admin', loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule), canActivate: [AuthGuard] },
  { path: 'report-builder', loadChildren: () => import('./modules/report-builder/report-builder.module').then(m => m.ReportBuilderModule), canActivate: [AuthGuard] },
  { path: 'referrals', loadChildren: () => import('./modules/referrals/referrals.module').then(m => m.ReferralsModule), canActivate: [AuthGuard] },
  { path: 'theater-slates', loadChildren: () => import('./modules/theater-slates/theater-slates.module').then(m => m.TheaterSlatesModule), canActivate: [AuthGuard] },
  { path: '**', component: ErrorComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
